var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTubeDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.125C18.5 10.1606 16.2612 11 13.5 11C10.7387 11 8.5 10.1606 8.5 9.125C8.5 8.08938 10.7387 7.25 13.5 7.25C16.2612 7.25 18.5 8.08938 18.5 9.125ZM8.5 11.1187V17.875C8.5 18.9106 10.7387 19.75 13.5 19.75C16.2612 19.75 18.5 18.9106 18.5 17.875V11.1187C17.3 11.8881 15.3969 12.25 13.5 12.25C11.6031 12.25 9.7 11.8881 8.5 11.1187Z",
    fill: "#6B6B6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeDisable);
export default __webpack_public_path__ + "static/media/tube_disable.f5d9820528e85556a78f48cddf5a24d2.svg";
export { ForwardRef as ReactComponent };